import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  useColorScheme,
  StyleSheet,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const HomeScreen = ({ navigation }) => {
  const isDarkMode = useColorScheme() === 'dark';

  const navigationOptions = [
    {
      name: '个人中心',
      icon: 'person',
      screen: 'Profile',
      color: '#2563eb',
      description: '查看和管理个人信息'
    },
    {
      name: '健康数据',
      icon: 'fitness',
      screen: 'HealthData',
      color: '#0891b2',
      description: '记录和追踪健康指标'
    },
    {
      name: '目标管理',
      icon: 'trophy',
      screen: 'Goal',
      color: '#0d9488',
      description: '设置和追踪健康目标'
    },
    {
      name: '食物管理',
      icon: 'nutrition',
      screen: 'FoodHome',
      color: '#ea580c',
      description: '查询食物营养信息'
    },
  ];

  return (
    <ScrollView 
      style={{
        flex: 1,
        backgroundColor: isDarkMode ? '#8fa0c1' : '#ffffff',
      }}
      contentContainerStyle={{ padding: 16 }}
    >
      <View style={{ 
        padding: 20, 
        borderRadius: 12, 
        backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
        marginBottom: 20,
      }}>
        <Text style={{ 
          fontSize: 24, 
          fontWeight: 'bold', 
          color: isDarkMode ? 'white' : '#1e3a8a',
          marginBottom: 8,
        }}>
          健康管理中心
        </Text>
        <Text style={{ 
          fontSize: 16, 
          color: isDarkMode ? '#e0e7ff' : '#3b82f6',
        }}>
          选择功能模块，开始您的健康管理之旅
        </Text>
      </View>

      <View style={{ 
        flexDirection: 'row', 
        flexWrap: 'wrap', 
        justifyContent: 'space-between',
      }}>
        {navigationOptions.map((option) => (
          <TouchableOpacity
            key={option.name}
            style={{
              width: '48%',
              marginBottom: 16,
              borderRadius: 12,
              padding: 16,
              backgroundColor: isDarkMode ? '#a9b6d0' : 'white',
              shadowColor: '#000',
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.1,
              shadowRadius: 4,
              elevation: 2,
            }}
            onPress={() => navigation.navigate(option.screen)}
          >
            <View style={{
              width: 50,
              height: 50,
              borderRadius: 25,
              backgroundColor: option.color,
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: 12,
            }}>
              <Ionicons name={option.icon} size={28} color="white" />
            </View>
            <Text style={{
              fontSize: 18,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 4,
            }}>
              {option.name}
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#6b7280',
            }}>
              {option.description}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    </ScrollView>
  );
};

export default HomeScreen; 